import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHubIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_5312_17909)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 30,
					cy: 30,
					r: 30,
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 30,
					cy: 26.8506,
					rx: 3.675,
					ry: 3.675,
					transform: "rotate(135 30 26.8506)",
					stroke: "#6BCABA",
					strokeWidth: 3
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.5689 24.0436C20.8109 19.8095 24.3149 16.5 28.5559 16.5H31.4441C35.6851 16.5 39.1891 19.8095 39.4311 24.0436L40.0168 34.2936C40.2791 38.8838 36.6275 42.75 32.0298 42.75H27.9702C23.3725 42.75 19.7209 38.8838 19.9832 34.2936L20.5689 24.0436Z",
					stroke: "#6BCABA",
					strokeWidth: 3
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24 36H36",
					stroke: "#865E9C",
					strokeWidth: 3,
					strokeLinecap: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_5312_17909",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 60,
				height: 60,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgHubIcon);
export { ForwardRef as ReactComponent };
